let floatAdded = false;
let footerVisible = false;


$(window).on('load scroll', function () {
  const scrollTop = $(this).scrollTop();
  if (scrollTop > 700 && !footerVisible) {
    if (!floatAdded) {
      $('.floating').addClass('is-active');

      floatAdded = true;
    }
  } else {
    if (floatAdded) {
      $('.floating').removeClass('is-active');

      floatAdded = false;
    }
  }
});


const footerObserver = new IntersectionObserver(function (entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      $('.floating').removeClass('is-active');

      footerVisible = true;
    } else {
      footerVisible = false;
      if ($(window).scrollTop() > 700) {
        $('.floating').addClass('is-active');

      }
    }
  });
});

footerObserver.observe(document.querySelector('footer'));


